import { render } from "./SupervisionReport.vue?vue&type=template&id=00f06ce4&ts=true"
import script from "./SupervisionReport.vue?vue&type=script&lang=ts"
export * from "./SupervisionReport.vue?vue&type=script&lang=ts"

import "./SupervisionReport.vue?vue&type=style&index=0&id=00f06ce4&lang=css"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__